// Format Firestore timestamps using the company's IANA timezone
// Usage: formatTimestamp(event.timestamp, "Asia/Dubai")

export function formatTimestamp(timestamp, timezone = "Asia/Dubai", options = {}) {
  if (!timestamp) return "—";
  const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp);

  const defaultOptions = {
    timeZone: timezone,
    day:    "2-digit",
    month:  "short",
    year:   "numeric",
    hour:   "2-digit",
    minute: "2-digit",
    hour12: true,
  };

  return date.toLocaleString("en-GB", { ...defaultOptions, ...options });
}

export function formatDate(timestamp, timezone = "Asia/Dubai") {
  if (!timestamp) return "—";
  const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp);
  return date.toLocaleString("en-GB", {
    timeZone: timezone,
    day:    "2-digit",
    month:  "short",
    year:   "numeric",
  });
}

export function formatTime(timestamp, timezone = "Asia/Dubai") {
  if (!timestamp) return "—";
  const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp);
  return date.toLocaleString("en-GB", {
    timeZone: timezone,
    hour:   "2-digit",
    minute: "2-digit",
    hour12: true,
  });
}

export function isToday(timestamp, timezone = "Asia/Dubai") {
  if (!timestamp) return false;
  const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp);
  const now  = new Date();
  const dateStr  = date.toLocaleDateString("en-GB", { timeZone: timezone });
  const todayStr = now.toLocaleDateString("en-GB",  { timeZone: timezone });
  return dateStr === todayStr;
}

export function startOfDayInTimezone(timezone = "Asia/Dubai") {
  const now     = new Date();
  const dateStr = now.toLocaleDateString("en-CA", { timeZone: timezone }); // YYYY-MM-DD
  const [y, mo, d] = dateStr.split("-").map(Number);
  const utcMidnight = new Date(Date.UTC(y, mo - 1, d));
  // Find what time UTC midnight is in the company timezone, then subtract that offset
  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone: timezone,
    hour: "2-digit", minute: "2-digit", second: "2-digit", hour12: false,
  }).formatToParts(utcMidnight);
  const h   = parseInt(parts.find(p => p.type === "hour").value)   % 24;
  const min = parseInt(parts.find(p => p.type === "minute").value);
  const s   = parseInt(parts.find(p => p.type === "second").value);
  let offsetMs = (h * 3600 + min * 60 + s) * 1000;
  if (h >= 12) offsetMs -= 86400 * 1000; // timezone is west of UTC (negative offset)
  return new Date(utcMidnight.getTime() - offsetMs);
}

// Returns today's date as "YYYY-MM-DD" in the company's timezone.
// Replaces new Date().toISOString().slice(0, 10) which is always UTC.
export function todayStringInTimezone(timezone = "Asia/Dubai") {
  return new Date().toLocaleDateString("en-CA", { timeZone: timezone });
}
